import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class DriverBank extends AbstractModel {
  @autoserialize
  driverId: number;

  @autoserialize
  balance: number;
}
